export default __webpack_public_path__ + "static/media/blockchain.c6ac6252.png";